export default __webpack_public_path__ + "static/media/712.46ffc1d1.svg";